import angular from 'angular';

import './table.styles.scss';

import TableController from './table.controller';

export default angular.module('autoboard.abTable', [])
  .directive('abTable', () => {
    'ngInject';

    return {
      controller: TableController,
      restrict: 'E',
      transclude: true,
      scope: {
        data: '<',
        sort: '<',
      },
      templateUrl: require('./table.template.html'),
      controllerAs: 'vm',
      bindToController: true,
    };
  })
  .name;
